module.exports = __webpack_public_path__ + "images/emoji/kiss.3b18faef261e18aea69b.png";